<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='expense'
            :expense='expense'
            :staff='staff'
            :payment_accounts='payment_accounts'
            @update='update'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <notes
            v-if='expense'
            :expense='expense'
            @update='update'
          ></notes>
        </v-col>
        <v-col cols='12' md='4'>
          <expense-summary
            v-if='expense'
            :expense='expense'
            :gst='gst'
            :subtotal='subtotal'
            :total='total'
          ></expense-summary>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <lines
            ref='expenseLines'
            v-if='expense'
            :expense='expense'
            @update='update'
            @updateTotals='updateTotals'
          ></lines>
        </v-col>
      </v-row>
      <v-row>
        <v-col class='text-right' offset-md='8' md='4'>
          <v-btn
            large
            :disabled='expense.is_posted'
            :elevation="expense.is_posted ? '' : '5' "
            color='info'
            @click='post'
            >
              Mark as Posted
            </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '../../../components/expense/Basics';
import Notes from '../../../components/expense/Notes';
import Lines from '../../../components/expense/Lines';
import Summary from '../../../components/expense/Summary';
import trackerAPI from '@/api/tracker';

import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'expense-overview',
  props: {
    expense: {
      required: true
    },
    staff: {
      required: true
    },
    payment_accounts: {
      required: true
    }
  },
  data: () => ({
    expenseCopy: {},
    total: 0,
    subtotal: 0,
    gst: 0
  }),
  methods: {
    async update (exp) {
      this.$emit('update', exp);
    },
    updateTotals(total, subtotal, gst){
      this.total = total;
      this.subtotal = subtotal; 
      this.gst = gst;
    },
    async post () {
      this.expenseCopy = _.cloneDeep(this.expense);
      this.expenseCopy.is_posted = true;
      this.expenseCopy.posting_date = moment().format('YYYY-MM-DD').toString();
     
      const tracker = {
          'tracker_data': {
            'description': "Marked expense as posted",
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'expense': this.expense.id
      }
      await trackerAPI.createExpenseTracker(tracker);
      this.$emit('update', this.expenseCopy);
    }
  },
  components: {
    'basics': Basics,
    'notes': Notes,
    'lines': Lines,
    'expense-summary': Summary,
  }
}
</script>
